import { useSearchV3, useToggleCustomerRegistryForLocationV3 } from '@ordr-as/ordr-service-types/epos';
import { isValidNumericLocationId } from '../utils/locationId';

export const useCustomerRegistryEnabled = (locationId: number) => {
  const { queryKey: _queryKey, ...result } = useToggleCustomerRegistryForLocationV3(locationId, {
    query: {
      enabled: isValidNumericLocationId(locationId),
    },
  });
  return result;
};

export const useCustomerRegistry = (locationId: number, query: string | undefined) => {
  const { queryKey: _queryKey, ...result } = useSearchV3(
    locationId,
    { query },
    {
      query: {
        enabled: isValidNumericLocationId(locationId),
      },
    }
  );
  return result;
};
